// @flow
import * as React from 'react';

import { getBoundingClientRect } from '@dnd-kit/core';
import t from './locale';
import cs from './styles.pcss';
import { getLocale } from '../../utils/i18n';
import settings from '../../settings';
import TermsAndConditionsModal from '../terms-and-conditions-modal';

const now = new Date();

type Props = {
  style?: any,
  windowWidth?: ?number,
};

export default function Footer({ style, windowWidth }: Props): React.Node {
  // 移除marginTop状态，避免循环刷新
  // const [marginTop, setMarginTop] = React.useState(0);
  const [showTermsModal, setShowTermsModal] = React.useState(false);
  const ref = React.useRef();

  // 禁用动态marginTop计算，让Footer回到正常文档流
  // React.useEffect(() => {
  //   if (ref && ref.current) {
  //     const rect = getBoundingClientRect(ref.current);
  //     const margin = Math.max(window.innerHeight - rect.bottom, 0);
  //     if (margin !== marginTop) {
  //       setMarginTop(margin);
  //     }
  //   }
  // }, [style, ref, windowWidth]);

  // 临时禁用用户状态加载，避免循环刷新
  // React.useEffect(() => {
  //   if (userTermsStatus !== null) {
  //     return;
  //   }
  //   const loadUserStatus = async () => {
  //     try {
  //       const response = await fetch('/terms_and_conditions/content', {
  //         method: 'GET',
  //         headers: {
  //           'X-Requested-With': 'XMLHttpRequest',
  //           'X-CSRF-Token': getCSRFToken(),
  //           'Content-Type': 'application/json'
  //         },
  //         credentials: 'same-origin'
  //       });
  //       if (response.ok) {
  //         const termsData = await response.json();
  //         setUserTermsStatus(termsData);
  //       }
  //     } catch (error) {
  //       console.error('Error loading user status:', error);
  //     }
  //   };
  //   loadUserStatus();
  // }, []);

  const getCSRFToken = () => {
    const meta = document.querySelector('meta[name="csrf-token"]');
    return meta ? meta.getAttribute('content') : '';
  };

  const handleTermsClick = async (e) => {
    e.preventDefault();

    try {
      // 获取用户状态，判断是否为日韩卖家
      const response = await fetch('/terms_and_conditions/content', {
        method: 'GET',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'X-CSRF-Token': getCSRFToken(),
          'Content-Type': 'application/json',
        },
        credentials: 'same-origin',
      });

      if (response.ok) {
        const termsData = await response.json();

        // 只有日韩卖家且已接受协议才显示弹框，否则跳转
        if (termsData.is_jp_kr_user && termsData.has_accepted_terms) {
          setShowTermsModal(true);
        } else {
          // 非日韩卖家或未接受协议的用户，跳转到 /articles/terms
          window.location.href = '/articles/terms';
        }
      } else {
        // 请求失败，默认跳转
        window.location.href = '/articles/terms';
      }
    } catch (error) {
      console.error('Error loading user terms status:', error);
      // 出错时默认跳转
      window.location.href = '/articles/terms';
    }
  };

  const handleCloseModal = () => {
    setShowTermsModal(false);
  };

  return (
    <div className={cs.footer}>
      <ul
        ref={ref}
        className={cs.disclaimer}
        style={{
          ...style,
          // 完全移除marginTop，避免循环刷新
          width: `${windowWidth ? `${windowWidth}px` : '100%'}`,
        }}
      >
        <li>
          <a
            href={settings.references.helpCenter}
            className={cs.disclaimerLink}
          >
            {t('helpCenter')}
          </a>
        </li>
        <li>
          <a
            href="/articles/terms"
            className={cs.disclaimerLink}
            onClick={handleTermsClick}
          >
            {t('terms')}
          </a>
        </li>
        <li>
          <a
            href={settings.references.faq(getLocale())}
            className={cs.disclaimerLink}
          >
            {t('faq')}
          </a>
        </li>
        <li>{t('copyright', { year: now.getFullYear() })}</li>
        <li>{t('message')}</li>
      </ul>

      {/* Terms & Conditions Modal - 简化为查看模式 */}
      <TermsAndConditionsModal
        isOpen={showTermsModal}
        onAccept={handleCloseModal}
        showCloseButton
        onClose={handleCloseModal}
        viewMode
      />
    </div>
  );
}
